export { StoreDetailSpot as default } from './StoreDetailSpot';
